import React, { useEffect } from "react";
import { startOfMonth, endOfMonth, format } from "date-fns";
import styles from "./style.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Avatar from "../../../../components/Avatar/Avatar";
import GoldMedal from "../../../../../../images/v2/GoldAward.png";
import SilverMedal from "../../../../../../images/v2/SilverAward.png";
import BronzeMedal from "../../../../../../images/v2/BronzeAward.png";
import { fetchGoalData } from "../../../../stores/dashboard";
import SetDailyGoalModal from "../set-daily-goal-modal";
import useDashboardStore from "../../../../stores/dashboard";
import Spinner from "../../../../components/Loaders/Spinner";
import useUserStore from "../../../../stores/user";

const MonthlyGoals = () => {
  const currentMonthStartDate = format(startOfMonth(new Date()), "dd MMM");
  const currentMonthEndDate = format(endOfMonth(new Date()), "dd MMM");
  const goalDataLoading = useDashboardStore((state) => state.goalDataLoading);
  const goalData = useDashboardStore((state) => state.goalData);
  const setDailyGoalModalOpen = useDashboardStore(
    (state) => state.setDailyGoalModalOpen,
  );
  const goalFilterKey = useDashboardStore((s) => s.goalFilterKey);
  const isAdmin = useUserStore((s) => s.isAdmin);
  const organizationId = useUserStore((s) => s.organizationId);

  const getInitials = (name) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  };

  const getMedal = (index) => {
    if (index === 0) return GoldMedal;
    if (index === 1) return SilverMedal;
    return BronzeMedal;
  };

  useEffect(() => {
    const abortController = new AbortController();
    fetchGoalData(
      goalFilterKey
        ? { user: goalFilterKey }
        : isAdmin
          ? { user: `org-${organizationId}` }
          : {},
      abortController,
    );

    return () => {
      abortController.abort();
    };
  }, [goalFilterKey, isAdmin, organizationId]);

  if (goalDataLoading) {
    return (
      <div
        className={styles.monthlyGoals}
        style={{
          minHeight: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.monthlyGoals}>
      <div className={styles.monthlyGoalsHeader}>
        <div className={styles.monthlyGoalsHeaderLeft}>
          <h2 className={styles.monthlyGoalsTitle}>Monthly Goals</h2>
          <p className={styles.monthlyGoalsDescription}>
            {currentMonthStartDate} - {currentMonthEndDate}
          </p>
        </div>
        <div className={styles.monthlyGoalsHeaderRight}>
          <ButtonIcon
            bgColor="#FFF"
            onClick={() => setDailyGoalModalOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M4.00002 6.5625V2.5C4.00002 2.36739 3.94734 2.24021 3.85357 2.14645C3.7598 2.05268 3.63262 2 3.50002 2C3.36741 2 3.24023 2.05268 3.14646 2.14645C3.05269 2.24021 3.00002 2.36739 3.00002 2.5V6.5625C2.56981 6.67265 2.1885 6.92285 1.9162 7.27365C1.64389 7.62446 1.49609 8.05591 1.49609 8.5C1.49609 8.94409 1.64389 9.37554 1.9162 9.72635C2.1885 10.0771 2.56981 10.3273 3.00002 10.4375V13.5C3.00002 13.6326 3.05269 13.7598 3.14646 13.8536C3.24023 13.9473 3.36741 14 3.50002 14C3.63262 14 3.7598 13.9473 3.85357 13.8536C3.94734 13.7598 4.00002 13.6326 4.00002 13.5V10.4375C4.43022 10.3273 4.81153 10.0771 5.08384 9.72635C5.35614 9.37554 5.50394 8.94409 5.50394 8.5C5.50394 8.05591 5.35614 7.62446 5.08384 7.27365C4.81153 6.92285 4.43022 6.67265 4.00002 6.5625ZM3.50002 9.5C3.30223 9.5 3.10889 9.44135 2.94445 9.33147C2.78 9.22159 2.65182 9.06541 2.57614 8.88268C2.50045 8.69996 2.48064 8.49889 2.51923 8.30491C2.55782 8.11093 2.65306 7.93275 2.79291 7.79289C2.93276 7.65304 3.11094 7.5578 3.30493 7.51921C3.49891 7.48063 3.69997 7.50043 3.8827 7.57612C4.06543 7.65181 4.2216 7.77998 4.33148 7.94443C4.44137 8.10888 4.50002 8.30222 4.50002 8.5C4.50002 8.76522 4.39466 9.01957 4.20712 9.20711C4.01959 9.39464 3.76523 9.5 3.50002 9.5ZM8.50002 3.5625V2.5C8.50002 2.36739 8.44734 2.24021 8.35357 2.14645C8.2598 2.05268 8.13262 2 8.00002 2C7.86741 2 7.74023 2.05268 7.64646 2.14645C7.55269 2.24021 7.50002 2.36739 7.50002 2.5V3.5625C7.06981 3.67265 6.6885 3.92285 6.4162 4.27365C6.14389 4.62446 5.99609 5.05591 5.99609 5.5C5.99609 5.94409 6.14389 6.37554 6.4162 6.72635C6.6885 7.07715 7.06981 7.32735 7.50002 7.4375V13.5C7.50002 13.6326 7.55269 13.7598 7.64646 13.8536C7.74023 13.9473 7.86741 14 8.00002 14C8.13262 14 8.2598 13.9473 8.35357 13.8536C8.44734 13.7598 8.50002 13.6326 8.50002 13.5V7.4375C8.93022 7.32735 9.31153 7.07715 9.58383 6.72635C9.85614 6.37554 10.0039 5.94409 10.0039 5.5C10.0039 5.05591 9.85614 4.62446 9.58383 4.27365C9.31153 3.92285 8.93022 3.67265 8.50002 3.5625ZM8.00002 6.5C7.80223 6.5 7.60889 6.44135 7.44445 6.33147C7.28 6.22159 7.15182 6.06541 7.07614 5.88268C7.00045 5.69996 6.98064 5.49889 7.01923 5.30491C7.05782 5.11093 7.15306 4.93275 7.29291 4.79289C7.43276 4.65304 7.61094 4.5578 7.80492 4.51921C7.99891 4.48063 8.19997 4.50043 8.3827 4.57612C8.56542 4.65181 8.7216 4.77998 8.83148 4.94443C8.94137 5.10888 9.00002 5.30222 9.00002 5.5C9.00002 5.76522 8.89466 6.01957 8.70712 6.20711C8.51959 6.39464 8.26523 6.5 8.00002 6.5ZM14.5 10.5C14.4996 10.0566 14.3521 9.62586 14.0807 9.27525C13.8092 8.92464 13.4292 8.67397 13 8.5625V2.5C13 2.36739 12.9473 2.24021 12.8536 2.14645C12.7598 2.05268 12.6326 2 12.5 2C12.3674 2 12.2402 2.05268 12.1465 2.14645C12.0527 2.24021 12 2.36739 12 2.5V8.5625C11.5698 8.67265 11.1885 8.92285 10.9162 9.27365C10.6439 9.62446 10.4961 10.0559 10.4961 10.5C10.4961 10.9441 10.6439 11.3755 10.9162 11.7263C11.1885 12.0771 11.5698 12.3273 12 12.4375V13.5C12 13.6326 12.0527 13.7598 12.1465 13.8536C12.2402 13.9473 12.3674 14 12.5 14C12.6326 14 12.7598 13.9473 12.8536 13.8536C12.9473 13.7598 13 13.6326 13 13.5V12.4375C13.4292 12.326 13.8092 12.0754 14.0807 11.7247C14.3521 11.3741 14.4996 10.9434 14.5 10.5ZM12.5 11.5C12.3022 11.5 12.1089 11.4414 11.9444 11.3315C11.78 11.2216 11.6518 11.0654 11.5761 10.8827C11.5004 10.7 11.4806 10.4989 11.5192 10.3049C11.5578 10.1109 11.6531 9.93275 11.7929 9.79289C11.9328 9.65304 12.1109 9.5578 12.3049 9.51921C12.4989 9.48063 12.7 9.50043 12.8827 9.57612C13.0654 9.65181 13.2216 9.77998 13.3315 9.94443C13.4414 10.1089 13.5 10.3022 13.5 10.5C13.5 10.7652 13.3947 11.0196 13.2071 11.2071C13.0196 11.3946 12.7652 11.5 12.5 11.5Z"
                fill="#3A383F"
              />
            </svg>
          </ButtonIcon>
        </div>
      </div>

      <div className={styles.progressList}>
        <div className={styles.progressItem}>
          <div className={styles.progressItemHeader}>
            <div className={styles.progressItemHeaderLeft}>
              <p>Submitted apps</p>
            </div>

            <div className={styles.progressItemHeaderRight}>
              <p>{goalData?.submittedApps?.perc}%</p>
            </div>
          </div>

          <div className={styles.progressContainer}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressBarFill}
                style={{
                  width: `${Math.min(goalData?.submittedApps?.perc, 100).toFixed(2)}%`,
                }}
              ></div>
            </div>
          </div>

          <div className={styles.progressItemFooter}>
            <p>
              {goalData?.submittedApps?.achieved}/
              {goalData?.submittedApps?.target || "Not set"}
            </p>
          </div>
        </div>

        <div className={styles.progressItem}>
          <div className={styles.progressItemHeader}>
            <div className={styles.progressItemHeaderLeft}>
              <p>Approved apps</p>
            </div>

            <div className={styles.progressItemHeaderRight}>
              <p>{goalData?.approvedApps?.perc}%</p>
            </div>
          </div>

          <div className={styles.progressContainer}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressBarFill}
                style={{
                  width: `${Math.min(goalData?.approvedApps?.perc, 100).toFixed(2)}%`,
                }}
              ></div>
            </div>
          </div>

          <div className={styles.progressItemFooter}>
            <p>
              {goalData?.approvedApps?.achieved}/
              {goalData?.approvedApps?.target || "Not set"}
            </p>
          </div>
        </div>

        <div className={styles.progressItem}>
          <div className={styles.progressItemHeader}>
            <div className={styles.progressItemHeaderLeft}>
              <p>Monthly processing volume</p>
            </div>

            <div className={styles.progressItemHeaderRight}>
              <p>{goalData?.monthlyVolume?.perc}%</p>
            </div>
          </div>

          <div className={styles.progressContainer}>
            <div className={styles.progressBar}>
              <div
                className={styles.progressBarFill}
                style={{
                  width: `${Math.min(goalData?.monthlyVolume?.perc, 100).toFixed(2)}%`,
                }}
              ></div>
            </div>
          </div>

          <div className={styles.progressItemFooter}>
            <p>
              $ {goalData?.monthlyVolume?.achieved}/ $
              {goalData?.monthlyVolume?.totalTarget || "Not set"}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.topPerformers}>
        <div className={styles.topPerformersHeader}>
          <h2 className={styles.topPerformersTitle}>
            Top performers of last month{" "}
          </h2>
        </div>

        <div className={styles.topPerformersLists}>
          {goalData?.topPerformers?.map((performer, index) => (
            <div key={index} className={styles.topPerformersList}>
              <div className={styles.topPerformersListItem}>
                <div className={styles.avatarContainer}>
                  <Avatar name={getInitials(performer?.name)} size="medium" />
                  <img
                    src={getMedal(index)}
                    alt="Gold Medal"
                    className={styles.medal}
                  />
                </div>
                <div className={styles.topPerformersListItemName}>
                  <p>{performer?.name}</p>
                </div>
              </div>
            </div>
          ))}

          {/* <div className={styles.topPerformersList}>
            <div className={styles.topPerformersListItem} >
              <div className={styles.avatarContainer} >
                <Avatar name="JD" size="medium" />
                <img src={SilverMedal} alt="Gold Medal" className={styles.medal} />
              </div>
              <div className={styles.topPerformersListItemName} >
                <p>John Doe</p>
              </div>
            </div>
          </div>

          <div className={styles.topPerformersList}>
            <div className={styles.topPerformersListItem} >
              <div className={styles.avatarContainer} >
                <Avatar name="JD" size="medium" />
                <img src={BronzeMedal} alt="Gold Medal" className={styles.medal} />
              </div>
              <div className={styles.topPerformersListItemName} >
                <p>John Doe</p>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <SetDailyGoalModal />
    </div>
  );
};

export default MonthlyGoals;
